/**
 * This is where all constants that are shared between client and server are defined
 * @module sharedConstants
 */

exports.NotificationType = {
   CreateCard: 0
}
exports.File = {
   UploadMax: 1000000
}

exports.WebSocket = {
   EventType: {
      Error: 0,
      MessageSent: 1,
      UpdateMessages: 2,
      Register: 3,
      UpdatePortfolio: 4,
      UpdatePortfolioList: 5,
      UpdateSponsorTyping: 6,

   }
};

exports.VoteType = {
   None: 0,
   DownVote: 1,
   UpVote: 2,
};

exports.DiscussionType = {
   Discussion: 0,
   QuestionAnswer: 1,
   Both: 2,
   None: 3
};

exports.CardType = {
   Evidence: 1,
   Reasoning: 2,
   Stimulus: 3,
   Note: 4,
   Synthesis: 5,
   Question: 6,
};

exports.CardLane= {
   Slow: 1,
   Fast: 2,
   Burst: 3,
};

exports.BracketCategory= {
   TopLeftBracket: { id: 0, name: "Life Sciences"},
   BottomLeftBracket: { id: 1, name: "Physics" },
   TopRightBracket: { id: 2, name: "Chemistry" },
   BottomRightBracket: { id: 3, name: "Computer Science" },
};

exports.Badges = {
   EvidenceContributorBadge: { id: 1, pointArray: [10, 35, 50] },
   ConjectureMakerBadge: { id: 2, pointArray: [5, 20, 50] },
   IncubatorStimulatorBadge: { id: 3, pointArray: [1, 5, 20] },
   MicroPubReviewerBadge: { id: 4, pointArray: [10, 50, 100] },
};


//1XX are delete versions of the XX values, adding cards use the same values as their cardType
exports.PortfolioActionType = {
   AddEvidence: exports.CardType.Evidence,
   AddReasoning: exports.CardType.Reasoning,
   AddNote: exports.CardType.Note,
   AddSynthesis: exports.CardType.Synthesis,
   AddQuestion: exports.CardType.Question,
   AddEvidenceComment: 20 + exports.CardType.Evidence,
   AddReasoningComment: 20 + exports.CardType.Reasoning,
   AddUser: 50,
   RemoveEvidence: 100 + exports.CardType.Evidence,
   RemoveReasoning: 100 + exports.CardType.Reasoning,
   RemoveNote: 100 + exports.CardType.Note,
   RemoveSynthesis: 100 + exports.CardType.Synthesis,
   RemoveQuestion: 100 + exports.CardType.Question,
   RemoveUser: 150,
   AnswerQuestion: 1001,
   IncubatorAddText: 2001,
   AddIncubatorComment: 2002,
};

exports.PortfolioActionText = {
   [exports.PortfolioActionType.AddEvidence]: 'Added Evidence ' +  String.fromCharCode(181) + 'Pub: ',
   [exports.PortfolioActionType.AddReasoning]: 'Added Conjecture ' +  String.fromCharCode(181) + 'Pub: ',
   [exports.PortfolioActionType.AddNote]: 'Added Note: ',
   [exports.PortfolioActionType.AddQuestion]: 'Asked a Question: ',
   [exports.PortfolioActionType.AddSynthesis]: 'Added Synthesis: ',
   [exports.PortfolioActionType.AddEvidenceComment]: 'Added Comment : ',
   [exports.PortfolioActionType.AddReasoningComment]: 'Added Comment: ',
   [exports.PortfolioActionType.AddUser]: 'Added User: ',
   [exports.PortfolioActionType.RemoveEvidence]: 'Removed Evidence ' +  String.fromCharCode(181) + 'Pub: ',
   [exports.PortfolioActionType.RemoveReasoning]: 'Removed Conjecture ' +  String.fromCharCode(181) + 'Pub: ',
   [exports.PortfolioActionType.RemoveNote]: 'Removed Note: ',
   [exports.PortfolioActionType.RemoveSynthesis]: 'Removed Synthesis: ',
   [exports.PortfolioActionType.RemoveUser]: 'Removed User: ',
   [exports.PortfolioActionType.AnswerQuestion]: 'Answered the Question: ',
   [exports.PortfolioActionType.IncubatorAddText]: 'Added a new Incubator description: ',
};

exports.ReviewQuestionValue = {
   Accept: 1,
   Revise: 2,
   Reject: 3,
   Pass: 4,
};

exports.TooltipValue = {
   FontSize:'16px',
   LineHeight: '18px'
}

exports.AchievementType = {
   IntroComplete: 2,
   FoundingMember: 3,
   InterestingConjecture: 4,
};

exports.PointBetType = {
   Invest: 0,
   Quarter: 1,
   Half: 2,
   Double: 3,
   Triple: 4,
   Quadruple: 5,
};

exports.PortfolioType = {
   Default: 0,
   Sponsored: 1,
   SponsoredPrivate: 2,
   SponsoredSemiPrivate: 3,
};

exports.DefaultIncubatorInstructions =
   "An Incubator is designed to help you and the Sponsor identify public Evidence and Conjecture µPubs, " +
   "that, if developed into private proposals, are within the scope of interest the Sponsor has committed to fund.\n\n" +

   "Think of it as a conversation. Plexors add Evidence and Conjecture µPubs from the feed to help advance the Sponsor’s " +
   "scope of interest. Conjecture µPubs are of particular interest because they provide potential connections among evidence. " +
   "Sponsors promote the µPubs and thinking that resonate the most with them.\n\n" +

   "Specific questions about the Incubator topic can be directly submitted to the Sponsor via the Incubator’s Discussion tab.\n\n" +

   "At the end of the Incubator period, Plexors and the Sponsor have a refined mutual understanding of questions " +
   "to be addressed in the proposal development. The Sponsor solicits research proposals and provides constructive " +
   "feedback to all submitters.\n\n" +

   "For additional information regarding an Incubator’s purpose and other specific instructions, refer to the " +
   "attachment(s) in the Incubator’s Overview tab.";

exports.AccountNotVerifiedText = 'Account email not verified.';